module.exports = "pegasus/assets/missing.png";